export const TEXT_CONSTANTS = {
  MAX_TEXT_LENGTH: 150,
} as const;
